/** Feature keys matching AppFeatureToggles.Key in the database. */
export const AppFeatureKeys = {
  ExampleModule: 'ExampleModule',
  ProjectManagement: 'ProjectManagement',
} as const

export type AppFeatureKey = (typeof AppFeatureKeys)[keyof typeof AppFeatureKeys]

const globalOnlyAppFeatureKeys = new Set<string>([])

/** Features controlled by the global toggle only (no per-customer assignment). */
export function isGlobalOnlyAppFeature(key: string): boolean {
  return globalOnlyAppFeatureKeys.has(key)
}
